import { jsx as f } from "react/jsx-runtime";
import u, { useLayoutEffect as I, useContext as d } from "react";
import A from "@indeed/indeed-gettext";
const c = "en-US", R = /* @__PURE__ */ new Set([
  "ar",
  "ar-AE",
  "ar-BH",
  "ar-EG",
  "ar-KW",
  "ar-MA",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "bn",
  "cs",
  "da",
  "de",
  "de-AT",
  "de-CH",
  "de-DE",
  "el",
  "en",
  "en-AE",
  "en-AQ",
  "en-AU",
  "en-BE",
  "en-BH",
  "en-CA",
  "en-CH",
  "en-EG",
  "en-GB",
  "en-HK",
  "en-ID",
  "en-IE",
  "en-IL",
  "en-IN",
  "en-KW",
  "en-LU",
  "en-MA",
  "en-MY",
  "en-NG",
  "en-NZ",
  "en-OM",
  "en-PH",
  "en-PK",
  "en-QA",
  "en-SA",
  "en-SG",
  "en-TH",
  "en-US",
  "en-VN",
  "en-ZA",
  "es",
  "es-AR",
  "es-CL",
  "es-CO",
  "es-CR",
  "es-EC",
  "es-ES",
  "es-MX",
  "es-PA",
  "es-PE",
  "es-US",
  "es-UY",
  "es-VE",
  "fi",
  "fr",
  "fr-BE",
  "fr-CA",
  "fr-CH",
  "fr-FR",
  "fr-LU",
  "fr-MA",
  "hi",
  "hl",
  "hm",
  "hu",
  "in",
  "it",
  "it-CH",
  "iw",
  "ja",
  "kn",
  "ko",
  "mr",
  "ms",
  "nl",
  "nl-BE",
  "no",
  "pl",
  "pt",
  "pt-BR",
  "pt-PT",
  "ro",
  "ru",
  "ru-UA",
  "sv",
  "ta",
  "te",
  "th",
  "tr",
  "uk",
  "uk-UA",
  "vi",
  "zh",
  "zh-HK",
  "zh-TW"
]), C = {
  bn: "IN",
  // Bengali - India
  cs: "CZ",
  // Czech - Czech Republic
  da: "DK",
  // Danish - Denmark
  el: "GR",
  // Greek - Greece
  fi: "FI",
  // Finnish - Finland
  hi: "IN",
  // Hindi - India
  hu: "HU",
  // Hungarian - Hungary
  ja: "JP",
  // Japanese - Japan
  kn: "IN",
  // Kannada - India
  ko: "KR",
  // Korean - Korea
  mr: "IN",
  // Marathi - India
  ms: "MY",
  // Malay - Malaysia
  nl: "NL",
  // Dutch - Netherlands
  no: "NO",
  // Norwegian - Norway
  pl: "PL",
  // Polish - Poland
  ro: "RO",
  // Romanian - Romania
  ru: "RU",
  // Russian - Russia
  sv: "SE",
  // Swedish - Sweden
  ta: "IN",
  // Tamil - India
  te: "IN",
  // Telugu - India
  th: "TH",
  // Thai - Thailand
  tr: "TR",
  // Turkish - Turkey
  uk: "UA",
  // Ukrainian - Ukraine
  vi: "VN",
  // Vietnamese - Vietnam
  zh: "CN"
  // Chinese - China
}, s = (e) => {
  try {
    const n = (e == null ? void 0 : e.trim().match(/^([a-z]{2})([_-]([a-z]{2}))?$/i)) || [], t = n[1];
    let r = n[3];
    return r || (r = C[t] || ""), new Intl.Locale([t.toLowerCase(), r.toLowerCase()].filter(Boolean).join("-"));
  } catch {
    return new Intl.Locale(c);
  }
}, E = (e) => {
  var r, o;
  let n;
  e != null && e.baseName ? n = e : typeof e == "string" && e.trim() && (n = s(e));
  let t = "ltr";
  return n && (t = ((r = n.getTextInfo) == null ? void 0 : r.call(n).direction) || ((o = n.textInfo) == null ? void 0 : o.direction) || "ltr"), t;
}, m = u.createContext({
  locale: new Intl.Locale(c),
  direction: "ltr",
  ...A({})
}), H = ({ locale: e, localeData: n = {}, children: t }) => {
  const r = u.useMemo(() => {
    var i;
    const o = s(e || ((i = n == null ? void 0 : n[""]) == null ? void 0 : i.Locale)), L = E(o);
    return {
      locale: o,
      direction: L,
      ...A(n)
    };
  }, [e, n]);
  return /* @__PURE__ */ f(m.Provider, { value: r, children: t });
}, S = (e) => {
  I(() => {
    const n = e != null && e.baseName ? e : s(e), t = E(n);
    document.documentElement.setAttribute("lang", n.language), document.documentElement.setAttribute("dir", t);
  }, [e]);
}, O = () => d(m);
export {
  c as DEFAULT_LOCALE,
  H as I18nProvider,
  R as SUPPORTED_LOCALES,
  E as getDirectionFromLocale,
  s as getLocale,
  S as useDocumentAttributesFromLocale,
  O as useI18n
};
